"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const FormError = (0, react_1.forwardRef)(({ className, error, ...props }, ref) => {
    return error ? ((0, jsx_runtime_1.jsx)("span", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-error-message', className), ...props, role: "alert", children: error })) : null;
});
exports.default = FormError;
